// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmallCards_sectionCards__HCml0{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
}
.SmallCards_sectionCardsContainer__b9YJC{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1478px;
    gap: 10px;
    flex-wrap: wrap;
    max-width: 2300px;
}
.SmallCards_card__ZTC6j{
    max-width: 350px;
    background-color: #fff;
    border-radius: var(--border-radius-lg);
    padding: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
.SmallCards_card__ZTC6j img{
    width: 330px;
    /* width: 100%; */
    height: auto;
    object-fit: cover;
}
.SmallCards_card__ZTC6j h3{
    font-size: var(--font-size-lg);
    font-weight: var(--font-bold);
    margin: 0;
    text-align: center;
    color: var(--color-background);
    height: 82px;
}
.SmallCards_card__ZTC6j p{
    font-size: var(--font-size-lg);
    font-weight: var(--font-regular);
    color: var(--color-background);
    margin: 0;
    text-align: center;
    height: 120px;
}
.SmallCards_card__ZTC6j span{
    font-size: var(--font-size-xl);
    font-weight: var(--font-regular);
    color: var(--color-background);
    margin: 0;
    text-align: center;
    
}
.SmallCards_price__8Mw1C{
    padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/CardsUI/SmallCards/SmallCards.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,sCAAsC;IACtC,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;;AAEtB;AACA;IACI,aAAa;AACjB","sourcesContent":[".sectionCards{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-top: 20px;\n    width: 100%;\n}\n.sectionCardsContainer{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 1478px;\n    gap: 10px;\n    flex-wrap: wrap;\n    max-width: 2300px;\n}\n.card{\n    max-width: 350px;\n    background-color: #fff;\n    border-radius: var(--border-radius-lg);\n    padding: 10px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n.card img{\n    width: 330px;\n    /* width: 100%; */\n    height: auto;\n    object-fit: cover;\n}\n.card h3{\n    font-size: var(--font-size-lg);\n    font-weight: var(--font-bold);\n    margin: 0;\n    text-align: center;\n    color: var(--color-background);\n    height: 82px;\n}\n.card p{\n    font-size: var(--font-size-lg);\n    font-weight: var(--font-regular);\n    color: var(--color-background);\n    margin: 0;\n    text-align: center;\n    height: 120px;\n}\n.card span{\n    font-size: var(--font-size-xl);\n    font-weight: var(--font-regular);\n    color: var(--color-background);\n    margin: 0;\n    text-align: center;\n    \n}\n.price{\n    padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionCards": `SmallCards_sectionCards__HCml0`,
	"sectionCardsContainer": `SmallCards_sectionCardsContainer__b9YJC`,
	"card": `SmallCards_card__ZTC6j`,
	"price": `SmallCards_price__8Mw1C`
};
export default ___CSS_LOADER_EXPORT___;
